/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Photos_Input_Add_PhotosInputs */

const en_admin_resources_photos_input_add_photos = /** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add photos`)
};

/** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */
const de_admin_resources_photos_input_add_photos = en_admin_resources_photos_input_add_photos;

/** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */
const es_admin_resources_photos_input_add_photos = en_admin_resources_photos_input_add_photos;

/** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */
const fr_admin_resources_photos_input_add_photos = en_admin_resources_photos_input_add_photos;

/** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */
const it_admin_resources_photos_input_add_photos = en_admin_resources_photos_input_add_photos;

/** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */
const pt_br2_admin_resources_photos_input_add_photos = en_admin_resources_photos_input_add_photos;

/** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */
const pl_admin_resources_photos_input_add_photos = en_admin_resources_photos_input_add_photos;

/** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */
const hu_admin_resources_photos_input_add_photos = en_admin_resources_photos_input_add_photos;

/** @type {(inputs: Admin_Resources_Photos_Input_Add_PhotosInputs) => LocalizedString} */
const ro_admin_resources_photos_input_add_photos = en_admin_resources_photos_input_add_photos;

/**
* | output |
* | --- |
* | "Add photos" |
*
* @param {Admin_Resources_Photos_Input_Add_PhotosInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_photos_input_add_photos = /** @type {((inputs?: Admin_Resources_Photos_Input_Add_PhotosInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Photos_Input_Add_PhotosInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_photos_input_add_photos(inputs)
	if (locale === "de") return de_admin_resources_photos_input_add_photos(inputs)
	if (locale === "es") return es_admin_resources_photos_input_add_photos(inputs)
	if (locale === "fr") return fr_admin_resources_photos_input_add_photos(inputs)
	if (locale === "it") return it_admin_resources_photos_input_add_photos(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_photos_input_add_photos(inputs)
	if (locale === "pl") return pl_admin_resources_photos_input_add_photos(inputs)
	if (locale === "hu") return hu_admin_resources_photos_input_add_photos(inputs)
	return ro_admin_resources_photos_input_add_photos(inputs)
});
export { admin_resources_photos_input_add_photos as "admin.resources.photos_input.add_photos" }